// 찜질방 장면을 프로토타입 순서대로 만든다: 메인 홀(서울 야경 포함) → 목욕탕 → 사우나 방들 → 장식 합치기 → 보행 격자 → 밤하늘 → TV 공연.
// 순서가 장식 합치기·자리 목록 순서에 영향을 준다. 프로토타입 buildJjim 2847–3182.
import * as THREE from 'three';
import type { NavGrid } from '../../engine/nav';
import { rinseMat } from '../water';
import { bakeStatic, createJjimBuild, type JFx, type JWall, type Spot } from './common';
import { buildHall } from './hall';
import { buildBath } from './bath';
import { buildSaunas } from './saunas';
import { buildJjimSky } from './seoul';
import { buildJjimGrids, type JObstacle } from './grid';
import { buildTvShow, type TvShow } from './tv';
import type { JArea } from './layout';

export interface JjimScene {
  world: THREE.Group;
  /** 구역별 그룹 (벽 투명도·보이기에 쓴다). */
  groups: Record<JArea, THREE.Group>;
  spots: Spot[];
  walls: JWall[];
  obj: JObstacle[];
  steam: THREE.Sprite[];
  fx: JFx;
  /** 어른용(놀이터 막힘)·아기용 보행 격자. */
  nav: NavGrid;
  navBaby: NavGrid;
  tvRT: THREE.WebGLRenderTarget;
  tv: TvShow;
}

export function buildJjimScene(parent: THREE.Object3D): JjimScene {
  const world = new THREE.Group();
  parent.add(world);
  const B = createJjimBuild(world, rinseMat);
  buildHall(B);
  buildBath(B);
  buildSaunas(B);
  bakeStatic(B);
  const { adult, baby } = buildJjimGrids(B.OBJ);
  buildJjimSky(world);
  const tv = buildTvShow();
  return { world, groups: B.groups, spots: B.JSPOTS, walls: B.JWALLS, obj: B.OBJ, steam: B.jjimSteam, fx: B.TV_FX, nav: adult, navBaby: baby, tvRT: B.tv.rt!, tv };
}
